import useTabState from '../hooks/useTabState';
import PageLayout from '../components/ui/PageLayout';
import TabBar from '../components/ui/TabBar';
import MyInbox from './MyInbox';
import ApprovalQueue from './ApprovalQueue';
import ProvisionalReview from './ProvisionalReview';
import Notifications from './Notifications';

const TABS = ['My Inbox', 'Approval Queue', 'Provisional Review', 'Notifications'] as const;
type Tab = typeof TABS[number];

export default function Operations() {
  const [activeTab, setActiveTab] = useTabState<Tab>('tab', TABS, 'My Inbox');

  return (
    <PageLayout title="Operations" subtitle="Daily tasks, approvals, and notifications">
      <TabBar
        tabs={TABS.map(t => ({ key: t, label: t }))}
        active={activeTab}
        onChange={v => setActiveTab(v as Tab)}
      />
      {activeTab === 'My Inbox' && <MyInbox />}
      {activeTab === 'Approval Queue' && <ApprovalQueue />}
      {activeTab === 'Provisional Review' && <ProvisionalReview />}
      {activeTab === 'Notifications' && <Notifications />}
    </PageLayout>
  );
}
